import { Component, inject } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatIconButton } from '@angular/material/button';
import { Router, RouterLink } from '@angular/router';
import { AsTenantService } from '../../services/as-tenant.service';

@Component({
  selector: 'app-as-tenant',
  imports: [MatIcon, MatIconButton, RouterLink],
  templateUrl: './as-tenant.component.html',
  styleUrl: './as-tenant.component.scss',
})
export class AsTenantComponent {
  private ats = inject(AsTenantService);
  private router = inject(Router);

  tenant = this.ats.selectedTenant();

  constructor() {}

  cancel(): void {
    this.router.navigate(['', 'mgmt', 'tenants']).then(() => this.tenant.set(null));
  }
}
